export const contactEmail = "hello@weizhi.me";

// Use the visitor's preferred email app rather than requiring a Gmail account.
export const projectInquiryUrl =
  `mailto:${contactEmail}?subject=Mobile%20app%20project%20inquiry&body=Project%20idea%3A%0APlatform%3A%0ATimeline%3A%0ABudget%20range%3A%0A`;

export const githubUrl = "https://github.com/xieweizhi";

export const location = "Tokyo, Japan (JST)";
export const availability = "Available for new projects";
